export default __webpack_public_path__ + "static/media/logofirstAD.37a5f700.png";